const cssStyles = () => `
.AlternativesSeparatorContinuous:before, .AlternativesSeparatorContinuous:after {
  background: rgba(0,0,0,0.2);
  -webkit-box-shadow: 0 1px 0 rgba(255,255,255,0.5);
  box-shadow: 0 1px 0 rgba(255,255,255,0.5);
  content: '';
  display: inline-block;
  height: 1px;
  position: relative;
  vertical-align: middle;
  width: 37%;
}
`;

export default cssStyles;
